@if (open()) {
  <div class="um-overlay" (click)="onClose()"></div>

  <aside class="um" role="dialog" aria-label="Upload mockups">
    <!-- header -->
    <header class="um-head">
      <button class="um-close" type="button" (click)="onClose()" aria-label="Close" [disabled]="uploading()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
          stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <div class="um-title">Upload Mockups</div>
      <div class="um-subtitle">Add one or more mockups to this project.</div>
    </header>

    <!-- body -->
    <div class="um-body">
      <label
        class="um-drop"
        [class.over]="dragOver()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave()"
        (drop)="onDrop($event)"
      >
        <input type="file" accept="image/*" multiple (change)="onFileSelected($event)" [disabled]="uploading()" hidden />
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
        </svg>
        <div class="um-drop-main">Drop mockups here</div>
        <div class="um-drop-sub">or click to browse · multiple files · up to 5 GB each</div>
      </label>

      @if (entries().length) {
        <div class="um-list">
          @for (entry of entries(); track entry.id) {
            <div class="um-row" [class.error]="entry.status === 'error'">
              <div class="um-thumb">
                @if (entry.previewUrl) {
                  <img [src]="entry.previewUrl" [alt]="entry.name" />
                } @else {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                    stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="9" cy="9" r="2" />
                    <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                  </svg>
                }
              </div>

              <div class="um-main">
                <div class="um-name" [title]="entry.name">{{ entry.name }}</div>
                <div class="um-meta">
                  <span class="um-size">{{ formatSize(entry.size) }}</span>
                  <span class="um-status" [class]="entry.status">
                    @switch (entry.status) {
                      @case ('preparing') { Preparing… }
                      @case ('ready') { Ready }
                      @case ('uploading') { Uploading {{ entry.progress }}% }
                      @case ('done') { Done }
                      @case ('error') { {{ entry.error }} }
                    }
                  </span>
                </div>
                @if (entry.status === 'uploading' || entry.status === 'done') {
                  <div class="um-bar">
                    <div class="um-bar-fill" [class.done]="entry.status === 'done'" [style.width.%]="entry.progress"></div>
                  </div>
                }
              </div>

              @if (entry.status === 'done') {
                <span class="um-check" aria-label="Uploaded">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"
                    stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </span>
              } @else if (!uploading()) {
                <button class="um-remove" type="button" (click)="removeEntry(entry.id)" aria-label="Remove">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- footer -->
    <footer class="um-foot">
      <div class="um-summary">
        @if (entries().length) {
          {{ entries().length }} file{{ entries().length === 1 ? '' : 's' }} · {{ formatSize(totalSize()) }}
        }
      </div>
      <div class="um-actions">
        <button class="um-btn ghost" type="button" (click)="onClose()" [disabled]="uploading()">Cancel</button>
        <button class="um-btn primary" type="button" (click)="startUploads()" [disabled]="!canStart()">
          @if (uploading()) {
            <span class="um-spinner" aria-hidden="true"></span> Uploading…
          } @else {
            Start Upload
          }
        </button>
      </div>
    </footer>
  </aside>
}
